import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { doAutionBid } from "../../../../redux/auction/action";
import Access from "../../../CustomComponents/Access/Access";
import ConfirmModal from "../../../Common/ConfirmModal";

// --- Added imports for Contract Modal ---
import { Modal } from "reactstrap";
import ContractView from "../../../CustomComponents/ContractView";
import PopupContractPrivacyPolicy from "../../../Common/PopupContractPrivacyPolicy";
import SignContractInput from "../../../Common/SignContractInput";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
// ----------------------------------------

export default function BitAuction({ getauctionbyid, setActiveTab }) {
  const dispatch = useDispatch();
  const { id } = useParams();

  // Profile selector to pre-fill the signature inputs
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const [modal, setModal] = useState(false); // Access modal
  const [submitFunc, setSubmitFunc] = useState(null); // Access submit
  const [bidstate, setBidstate] = useState(0); // Access submit
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false); // Confirmation modal

  // --- Added State for Contract Modal ---
  const [contractModal, setContractModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);
  
  // Temporary storage to hold the bid details before signature completion
  const [tempValues, setTempValues] = useState(null);
  const [tempResetForm, setTempResetForm] = useState(null);
  // --------------------------------------

  // Yup validation schema for Bid Form
  const validationSchema = Yup.object().shape({
    bid: Yup.number().typeError("Bid must be a number")
      .required("Bid is required")
      .positive("Bid must be a positive number")
      .min(1, "Bid must be at least 1"),
  });

  // Actual bid submission logic merged with signature values
  const AutionBid = async (values, signValues, resetFormFunc) => {
    setLoading(true);
    const data = {
      type: "1",
      price: values.bid,
      auction_id: id,
      first_name: signValues?.first_name || "",
      last_name: signValues?.last_name || "",
      image: "image.png"
    };
    try {
      const res = await dispatch(doAutionBid(data));
      if (res?.data?.status) {
        resetFormFunc(); // Reset input
        setActiveTab("bid");
        window.scrollTo({
          top: window.innerHeight + window.scrollY,
          behavior: "smooth",
        });
      }
    } catch (error) {
      console.error("Bid submission failed:", error);
    } finally {
      setLoading(false);
      setModal(false);
    }
  };

  // --- Formik configuration for the Signature Popup ---
  const signFormik = useFormik({
    initialValues: {
      first_name: profile?.first_name || "",
      last_name: profile?.last_name || "",
      agree: false,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      agree: Yup.boolean().oneOf([true], "You must agree to the terms"),
    }),
    onSubmit: async (signValues) => {
      // Wrap the final API call (combining bid + signature data) for the Access modal to execute
      const wrappedSubmit = () => AutionBid(tempValues, signValues, tempResetForm);
      setSubmitFunc(() => wrappedSubmit);
      setContractModal(false);
      setModal(true); // Show Access modal to finalize action
    },
  });
  // ----------------------------------------------------

  // Trigger Validation, store bid, and show the Confirmation Modal
  const checkaccessss = (values, resetForm, validateForm, setTouched) => {
    setTouched({ bid: true });
    setBidstate(values?.bid);
    
    // Run validation manually before prompting
    validateForm().then((formErrors) => {
      if (Object.keys(formErrors).length > 0) {
        return; // Stop if validation fails
      }

      // Store pending submit items
      setTempValues(values);
      setTempResetForm(() => resetForm);

      // Open the standard confirm modal first
      setConfirmModal(true); 
    });
  };

  return (
    <>
      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(false)}
        title="Confirm Bid"
        message={`You're about to bid $${bidstate}. Do you want to continue?`}
        onConfirm={() => {
          setConfirmModal(false); // Close Confirmation
          
          if (getauctionbyid?.my_bid > 0 || getauctionbyid?.agreement_pdf) {
            // It's an UPDATE BID: Skip Contract Modal
            const wrappedSubmit = () => AutionBid(
              tempValues, 
              { first_name: profile?.first_name, last_name: profile?.last_name }, 
              tempResetForm
            );
            setSubmitFunc(() => wrappedSubmit);
            setModal(true); // Open Access modal directly
          } else {
            // It's a PLACE BID: Open Contract View after confirming
            setContractModal(true); 
          }
        }}
      />

      <Formik
        initialValues={{ bid: "" }}
        validationSchema={validationSchema}
        onSubmit={() => { /* Handled manually via our checkaccessss method */ }}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({ resetForm, values, validateForm, setTouched }) => (
          <>
            {/* Access modal for permission checks */}
            {modal && submitFunc && (
              <Access
                modal={modal}
                setModal={setModal}
                state={"state"}
                checkpermission={"bid_auction"}
                hitmethod={submitFunc} // Executes the wrapped AutionBid logic
                masterID={getauctionbyid?.id}
                checkrole={false}
              />
            )}

            {/* Bid Form */}
            <Form className="input-button flex-wrap">
              <div className="d-flex align-items-center w-100" style={{ columnGap: '20px' }}>
                <div className="bid-input">
                  <Field
                    type="number"
                    name="bid"
                    className="form-control"
                    placeholder="Enter your bid"
                  />
                </div>

                <button
                  type="button"
                  className="btn purchase-btn w-100 dis-margin"
                  disabled={loading}
                  onClick={() => checkaccessss(values, resetForm, validateForm, setTouched)}
                >
                  {loading
                    ? "Processing..."
                    : getauctionbyid?.my_bid > 0
                      ? "Update Bid"
                      : "Place Bid"}
                </button>
              </div>
              <div className="col-md-12">
                <ErrorMessage
                  name="bid"
                  component="div"
                  className="error-message text-danger"
                />
              </div>
            </Form>
          </>
        )}
      </Formik>

      {/* ---------------- Contract Modal ---------------- */}
      {contractModal && (
        <Modal
          isOpen={contractModal}
          size="lg"
          className="modal-centered contract-modal contract"
          toggle={() => setContractModal(false)}
        >
          <div className="contract-sec p-4" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="website-design mb-4">
              {/* Type set to auction_agreement strictly as requested */}
              <ContractView type={'auction_agreement'} />
            </div>

            <form onSubmit={signFormik.handleSubmit}>
              <SignContractInput formik={signFormik} />

              <div className="checkbox mt-3">
                <input
                  type="checkbox"
                  id="agree"
                  name="agree"
                  checked={signFormik.values.agree}
                  readOnly
                  onClick={() => {
                    if (!signFormik.values.agree) {
                      setPrivacyModal(true);
                    } else {
                      signFormik.setFieldValue("agree", !signFormik.values.agree);
                    }
                  }}
                />
                <label htmlFor="agree">
                  Yes, I understand and agree to Urxprt’s <span> Terms of Service</span>,
                  including the <span> User Agreement</span> and <span>Privacy Policy</span>.
                </label>
                {signFormik.touched.agree && signFormik.errors.agree ? (
                  <div className="error text-danger">{signFormik.errors.agree}</div>
                ) : null}
              </div>

              <div className="submit-btn mt-4 d-flex justify-content-end" style={{ gap: "10px" }}>
                <button
                  type="button"
                  className="btn"
                  onClick={() => setContractModal(false)}
                >
                  Back
                </button>
                <button type="submit" className="btn post-btn" disabled={loading}>
                  {loading ? <LoginLoaderButton /> : "Accept & Publish"}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      )}

      {/* ---------------- Privacy Policy Nested Modal ---------------- */}
      {privacyModal && (
        <Modal
          isOpen={privacyModal}
          keyboard={false}
          className="modal-width modal-centered popupmodal termsconditionmodal"
        >
          <PopupContractPrivacyPolicy formik={signFormik} setModal={setPrivacyModal} />
        </Modal>
      )}
    </>
  );
}